import type { Move } from 'chessboard/model/move/types';

/**
 * Try moving forward
 */
export function tryMovingForward(params: Move.ForwardWithContext) {
  const { move, followContinuations = true, steps = 1, context } = params;
  const { mutateGame, game } = context;

  const startIds = game.ids();

  const firstStepData = mutateGame(function callMethod() {
    game.moveForward(followContinuations, move);
  });

  let success = firstStepData?.plyDiff === 1;

  if (steps > 1 && success) {
    // starting from index 1 as first step has already been consumed
    for (let i = 1; i < steps; i++) {
      success = game.moveForward(followContinuations);

      if (!success) {
        break;
      }
    }
  }

  const endIds = game.ids();

  game.selectPosition(startIds.move, startIds.line);

  return {
    firstStepData,
    startIds,
    endIds,
    success,
  };
}
